export default {
  delete_success: 'Tarjous poistettiin onnistuneesti',
  delete_failed: 'Tarjouksen poistaminen epäonnistui',
  delete_confirm_title: 'Haluatko varmasti poistaa tämän tarjouksen?',
  delete_last_day_confirm_title: 'Viimeisen jäljellä olevan päivän poistaminen poistaa tämän tarjouksen. Oletko varma?',
  confirm: 'Vahvista',
  cancel: 'Peruuta',
  qualifying_items: 'Vaaditut tuotteet',
  free_items: 'Ilmaiset tuotteet',
  all_day: 'Koko päivän',
  starts_on: 'Alkaa {{date}}',
  ends_on: 'Päättyy {{date}}',
  ends_when_deleted: 'Päättyy, kun poistetaan',
  off: '{{amount}} alennus',
  min_spend_value: 'Väh. ostos: {{amount}}',
};
